<div class="tw-w-full tw-h-full tw-max-h-[100vh] tw-overflow-auto tw-p-5">
  <app-menu-mobile></app-menu-mobile>
  <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-xl tw-text-secondary tw-mb-5">{{ "businesses" | translate }}</p>
  <div class="tw-w-full tw-h-fit tw-flex max-md:tw-justify-end tw-flex-wrap-reverse md:tw-flex-wrap tw-gap-4 tw-mb-5">
    <div class="tw-w-full md:tw-max-w-72 tw-h-12 tw-relative tw-flex tw-bg-white tw-border tw-border-grey-600 tw-rounded-[5px] tw-overflow-auto tw-px-4 tw-py-3">
      <input
        #searchInput
        class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-bg-transparent tw-text-secondary tw-outline-none tw-pr-8"
        [(ngModel)]="search"
        (change)="setSearch($event)"
        [placeholder]="'search-here' | translate"
      />
      <img class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-right-4" src="../../../assets/search-icon.svg" />
    </div>
    <app-button src="../../../../assets/add-icon.svg" [text]="'add-business' | translate" [onButtonClick]="addBusiness.bind(this)"></app-button>
  </div>
  <app-table
    [items]="businesses"
    [columns]="[
      { header: 'name', field: 'name' },
      { header: 'currency', field: 'currency' },
      { header: 'payment-options', field: 'paymentOptionsString' },
      { header: 'banner', field: 'bannerURL', type: 'image' },
    ]"
    [editFunction]="editBusiness"
    [deleteFunction]="deleteBusinessPopup.bind(this)"
    [emptyMessage]="'no-businesses-found' | translate"
    [loading]="loading"
    [page]="page"
    [pageSize]="pageSize"
    [totalRecords]="totalItems"
    (pageChange)="onPageChange($event)"
  >
  </app-table>
  <div class="tw-w-full tw-h-20"></div>
</div>
